import bus from '@/bus';

const SNACK_BAR_EVENT = 'SNACK_BAR';

async function callHttp(url, propertyName) {
	try {
		const response = await this.$http.get(url);
		if (response.data[0].name) {
			this[propertyName].push({ id: 0, name: 'All' });
		} else {
			this[propertyName].push({ id: 0, number: 'All' });
		}
		response.data.forEach((dataSingle) => {
			this[propertyName].push(dataSingle);
		});
	} catch (error) {
		this.showNotification(
			'Ocurrió un error al intentar cargar la data, es probable que no se haya configurado la data necesaria.',
			'error',
		);
	}
}

function renderFilter(key, id, operator) {
	const filter = {
		filters: [{
			key,
			value: id,
			operator,
		}],
	};
	return filter;
}

function renderSort(key, direction) {
	const sort = {
		key,
		direction,
	};
	return sort;
}

function loadBuildingsAndSubsidiaries() {
	const promises = [
		this.$http.get('building-simple-list'),
		this.$http.get('subsidiary-simple-list'),
	];
	return Promise.all(promises).then((response) => {
		this.buildings = response[0].data;
		this.subsidiaries = response[1].data;
		return [this.buildings, this.subsidiaries];
	});
}

async function exportToCSV(fieldNames, columns, rows, fileName) {
	const model = {
		fieldNames,
		columns,
		rows,
	};
	try {
		const response = await this.$http.post(`${process.env.PRODUCTS_URL}/exports-csv`, model);
		const reader = new FileReader();
		const out = new Blob([response.data], { type: 'text/csv' });
		reader.onload = () => {
			const link = document.createElement('a');
			link.download = `${fileName}.csv`;
			link.href = reader.result;
			link.click();
		};
		reader.readAsDataURL(out);
	} catch (err) {
		this.showNotification('Error interno de servidor, por favor recargue la página e intente de nuevo', 'error');
	}
}

function data() {
	return {
		bookingsAmountTotal: 0,
		bookingsTotal: 0,
		buildings: [],
		filter: [],
		page: 1,
		sort: [
			{
				key: 'created_at',
				direction: 'DESC',
			},
		],
		totalPages: 0,
		subsidiaries: [],
		rooms: [],
		roomTypes: [],
	};
}

async function loadBookingsTotal(subsidiaryId) {
	const params = { subsidiaryId };
	try {
		const { data: bookings } = await this.$http.get(`${process.env.PMS_URL}/bookings-details`,
			{ params });
		this.bookingsTotal = bookings.data.availabiliy.occupied;
		this.bookingsAmountTotal = bookings.data.amount;
	} catch (err) {
		this.showNotification('No se pudo calcular el total de las reservas para este hotel.',
			'error');
	}
}

function loadBuildings() {
	callHttp.call(this, 'building-simple-list', 'buildings');
}

function loadSubsidiaries() {
	callHttp.call(this, 'subsidiary-simple-list', 'subsidiaries');
}

function loadRoomTypes() {
	callHttp.call(this, 'roomtype-simple-list', 'roomTypes');
}

function loadRooms() {
	callHttp.call(this, 'room-simple-list', 'rooms');
}

function mixinSearchCustomer(documentType, numDocument) {
	const url = Number(documentType) === 4 ? `${process.env.PERU_DATOS_URL}/ruc/${numDocument}`
		: `${process.env.PMS_URL}/customer-search`;
	const params = Number(documentType) === 4 ? {} : { numDocument, documentType };
	return this.$http.get(url, { params });
}

function showNotification(message, type = 'primary') {
	bus.$emit(SNACK_BAR_EVENT, {
		message,
		error: type === 'error',
		info: type === 'info',
		visible: true,
		primary: type === 'primary',
		secondary: type === 'secondary',
		success: type === 'success',
		warning: type === 'warning',
	});
}

const mixin = {
	data,
	methods: {
		exportToCSV,
		loadBookingsTotal,
		loadBuildings,
		loadSubsidiaries,
		loadRooms,
		loadRoomTypes,
		loadBuildingsAndSubsidiaries,
		mixinSearchCustomer,
		renderFilter,
		renderSort,
		showNotification,
	},
};

export default [mixin];



// WEBPACK FOOTER //
// ./src/shared/mixins.js